import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminQuestionDetail = {
  pageTitle: "题目详情",
  notFound: "未找到对应题目。",
  subTitleVersioned: "题目版本编号 {versionedCode}",
  actions: {
    publish: "发布题目",
    archive: "归档",
    viewing: "查看中",
    viewVersion: "查看该版本",
  },
  tabs: {
    preview: "考生视角",
    config: "题型配置",
    experience: "完整信息",
    versions: "版本历史",
    json: "结构化 JSON",
  },
  archiveConfirm: {
    title: "确认归档该题目？",
    description: "归档后默认不在常用列表展示。",
  },
  archivedAlert: {
    message: "当前题目已归档",
    description: "归档题目默认只读展示；如需继续迭代，请复制结构新建题目或恢复到草稿后再编辑。",
  },
  sections: {
    basicInfo: "基础信息",
    versions: "版本历史与差异",
    content: "题目内容与结构化数据",
  },
  versionDiff: {
    expandLabel: "展开查看版本历史与差异",
    compareA: "对比版本 A",
    compareB: "对比版本 B",
    compareTitle: "对比：{from} -> {to}",
    scalarChanges: "基础字段变更（{count}）",
    jsonChanges: "JSON 结构变更（{count}）",
    rawJsonChanges: "原始 JSON 结构变更（{count}）",
    pickDifferent: "请选择两个不同版本进行对比。",
    viewingCurrent: "当前查看：",
    singleVersionLabel: "当前版本：",
    singleVersionHint: "当前仅有 1 个版本，暂无可对比的历史变更。",
    backToLatest: "返回最新版本",
    snapshotTitle: "版本快照：{code}",
    loadSnapshotFailed: "加载版本快照失败",
    summary: {
      total: "总变更 {count}",
      scalar: "基础字段 {count}",
      json: "JSON 字段 {count}",
      cases: "用例变更 {count}",
    },
    readable: {
      title: "可读变更视图",
      stem: "题干",
      starterCode: "模板代码",
      publicCases: "公开用例",
      hiddenCases: "隐藏用例",
      judgeConfig: "评测配置",
      analysis: "解析",
      metadata: "AI 元数据",
      choiceSection: "选择题/判断题差异",
      shortAnswerSection: "简答题差异",
      environmentSection: "环境配置差异",
      starterCodeCompare: "模板代码对比",
      caseChanges: "用例差异明细",
      caseScope: "用例分组",
      caseNo: "用例编号",
      caseField: "字段",
    },
  },
  overview: {
    type: "题型",
    status: commonShortNouns.status,
    currentVersion: "当前版本",
    difficulty: "难度",
    reviewStatus: "审核状态",
    mainCode: "题目编号",
    versionedCode: "题目版本编号",
    createdAt: commonShortFieldLabels.createdAt,
    latestVersionCreatedAt: "最新版本创建时间",
    internalNote: "备注（仅后台可见）",
  },
  content: {
    candidateView: "考生视角",
    typeConfig: "题型配置",
    structuredJson: "结构化 JSON",
    previewTitle: "题目预览（考生视角）",
    codeConfigTitle: "编程题配置",
    tryRunTitle: "在线试跑（管理员）",
    practicalConfigTitle: "实操题配置（表单视图）",
    attackDefenseConfigTitle: "夺旗题容器配置（表单视图）",
    adminExperienceTitle: "管理员体验（当前会话）",
    rawJsonContent: "content_json（原始）",
    rawJsonAnswer: "answer_json（原始）",
    rawJsonAnalysis: "analysis_json（原始）",
    rawJsonAi: "ai_metadata_json（原始）",
  },
  paperReferences: {
    title: "试卷引用",
    empty: "当前题目暂未被任何试卷引用",
    total: "引用总数",
    paperCount: "涉及试卷",
    publishedPaperCount: "已发布试卷",
    currentVersionRefs: "当前试卷版本引用",
    latestQuestionVersionRefs: "最新题目版本引用",
    latestPaper: "最近引用试卷",
    viewAll: "查看全部引用明细",
    drawerTitle: "试卷引用明细（共 {count} 条）",
    table: {
      paper: "试卷",
      status: commonShortNouns.status,
      paperVersion: "试卷版本",
      questionVersion: "题目版本",
      position: "位置",
      score: "分值",
      actions: "操作",
    },
    labels: {
      current: "当前",
      history: "历史",
      latest: "最新",
      outdated: "旧版",
    },
  },
  question: {
    taskTitle: "题目名称",
    taskDescription: "题目描述",
    stem: "题干",
    options: "选项",
    optionFallback: "选项 {index}",
    correctAnswer: "标准答案（仅后台可见）",
    analysis: "解析",
    referenceAnswer: "参考答案（仅后台可见）",
    keywords: "关键词（仅后台可见）",
    keyPoints: "得分点（仅后台可见）",
  },
  environment: {
    environmentType: "环境类型",
    environmentService: "环境服务",
    resourceProvider: "资源提供者",
    checkMode: "检测模式",
    labService: "Lab Service",
    image: "镜像标识",
    containerPort: "容器端口",
    accessHint: "访问说明",
    dynamicFlag: "动态 Flag",
    dynamicFlagOn: "开启",
    dynamicFlagOff: "关闭",
    deliveryMode: "载体",
    staticCarrier: "静态题载体",
    carrierAttachment: "附件",
    carrierContainer: "容器",
    attachmentRefs: "附件引用",
    standardFlag: "标准 Flag（仅后台可见）",
    hint: "提示",
  },
  code: {
    supportedLanguages: "支持语言",
    defaultLanguage: "默认语言",
    timeLimit: "时间限制",
    memoryLimit: "内存限制",
    executionHint: "运行提示",
    starterCode: "模板代码",
    starterCodeEmpty: "// 无模板代码",
    publicCases: "示例/公开用例",
    caseTitle: "用例 {index}",
    publicCaseLabel: "公开用例 {index}",
    input: "输入",
    output: "输出",
    explanation: "解释",
    hiddenCaseCount: "隐藏用例数量",
    hiddenCasesTitle: "隐藏用例（仅管理员可见）",
    hiddenCaseTitle: "隐藏用例 {index}",
    hiddenCaseLabel: "隐藏用例 {index}",
  },
  tryRun: {
    runLanguage: "运行语言",
    sourceCode: "代码",
    tip: "支持缩进与语法高亮，快捷键：Ctrl/Cmd + Enter 运行。",
    runAllCases: "运行全部用例",
    running: "正在运行全部用例",
    runningDescription: "请稍候，运行结束后会自动展示结果。",
    failed: "运行失败",
    summary: "共 {total} 条用例，通过 {passed} 条",
    actualOutput: "实际输出",
    saveAsNewVersion: "保存为新版本（+1）",
    fillStarterCode: "填充模板代码",
    result: "结果：",
    rawDetail: "评测详情（原始）",
    selectLanguage: "请选择运行语言",
    inputCode: "请填写代码",
    verdictContractAnomaly: "运行结果合同异常：{value}",
    caseStatusContractAnomaly: "用例状态合同异常：{value}",
  },
  practical: {
    containerInstance: "容器实例",
    instanceStatus: "实例状态",
    webEndpoint: "Web 入口",
    notCreated: "未创建",
    rerunInitScript: "重跑初始化脚本",
    runCheckScript: "执行检查脚本",
    initScript: "初始化脚本",
    checkScript: "检查脚本",
    initScriptEditable: "初始化脚本（可修改后重跑）",
    checkScriptEditable: "检查脚本（可修改后执行）",
    lastAction: "最近操作：",
    lastActionInit: "初始化脚本",
    lastActionCheck: "检查脚本",
    attackDefenseCheckScriptNote: "夺旗题体验不使用检查脚本，改为手工输入 Flag 校验。",
    flagValidation: "Flag 校验（管理员体验）",
    flagPlaceholder: "输入 flag{...}",
    validateFlag: "校验 Flag",
    lastValidation: "最近校验结果：",
    validationCorrect: "正确",
    validationIncorrect: "错误",
    debugNote:
      "可在此直接修改脚本后创建或重跑环境做验证；当前编辑内容仅用于调试，不会自动保存到题目配置。",
    debugInitOnlyNote:
      "可在此直接修改初始化脚本后创建或重跑环境做验证；当前编辑内容仅用于调试，不会自动保存到题目配置。",
    initScriptDebug: "初始化脚本（调试编辑）",
    checkScriptDebug: "检查脚本（调试编辑）",
    callbackModeNoCheck: "当前为 callback 模式，通常无需平台侧检查脚本。",
  },
  messages: {
    updated: "题目已更新",
    updateSuccess: "题目更新成功（仅内容变更时才会创建新版本）",
    deleteSuccess: "题目删除成功",
    publishSuccess: "题目已发布",
    archiveSuccess: "题目已归档",
    tryRunSuccess: "试跑完成",
    tryRunSavedAsVersion: "已保存为新版本 V{versionNo}",
    envNotSupport: "当前题目不支持容器体验",
    imageMissing: "当前题目未配置镜像标识",
    initScriptFailed: "初始化脚本执行失败",
    sessionPersistFailed: "体验环境已创建，但会话持久化失败",
    envCreateInitFailed: "体验环境创建成功，但初始化脚本执行失败：{error}",
    envCreateInitSuccess: "体验环境创建成功，初始化脚本已执行：{status}",
    envCreateSuccess: "体验环境创建成功",
    pleaseCreateEnv: "请先创建体验环境",
    scriptEmptyInit: "初始化脚本为空",
    scriptEmptyCheck: "检查脚本为空",
    actionInit: "初始化",
    actionCheck: "检查",
    actionSuccess: "{action}执行成功",
    actionFailed: "{action}执行失败（{status}）：{detail}",
    checkScriptPassed: "检查脚本通过（退出码 0）",
    checkScriptFailed: "检查脚本未通过（退出码 {exitCode}）",
    nonZeroExit: "脚本返回非 0 退出码",
    notAttackDefenseEnv: "当前不是可体验容器的夺旗题",
    pleaseInputFlag: "请先输入 flag",
    dynamicFlagMissing: "容器内未读取到动态 flag 环境变量：{envKey}",
    staticFlagMissing: "当前静态 flag 未配置",
    flagPass: "Flag 校验通过",
    flagWrong: "Flag 不正确，请重试",
    envDestroyed: "体验环境已销毁",
    sessionCleaned: "已清理失效的体验环境会话，请重新创建体验环境。",
  },
  confirmDelete: {
    title: "确认删除这个题目吗？",
    description: "仅未被试卷或作答引用的题目允许删除。",
  },
  edit: {
    title: "编辑题目",
    note: "仅当题目内容发生变化时才会自动创建新版本并将版本加 1；如果只是修改状态（草稿/发布），版本保持不变。",
    statusLabel: "状态",
    saveChanges: "保存修改",
    preview: "预览",
    previewTitle: "题目预览（考生视角）",
  },
  table: {
    field: "字段",
    oldValue: "旧值",
    newValue: "新值",
    jsonField: "JSON 字段",
    path: "路径",
    changeType: "变更类型",
    versionNo: "版本",
    versionedCode: "题目版本编号",
    title: "标题",
    createdAt: commonShortFieldLabels.createdAt,
    actions: "操作",
  },
  diffChangeType: {
    added: "新增",
    removed: "删除",
    updated: "修改",
  },
  rawJsonTitle: "结构化 JSON",
} as const;
